/**
 * Admin Utils Export
 *
 * @since 1.0.0
 */

export * from './navigation-guard';
export type { NavigationGuardState } from './types';

